export const requiredInputs = ["First name", "Last name", "Company", "Email", "Storage size"];
